import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranslationblack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M.506 8.309A7.478 7.478 0 0 0 2.7 13.3 7.477 7.477 0 0 0 8 15.5a7.477 7.477 0 0 0 5.3-2.2A7.477 7.477 0 0 0 15.5 8a7.477 7.477 0 0 0-2.2-5.3A7.477 7.477 0 0 0 8 .5c2.071 0 3.946.84 5.303 2.197A7.477 7.477 0 0 1 15.5 8c0 2.071-.84 3.946-2.197 5.303A7.477 7.477 0 0 1 8 15.5a7.477 7.477 0 0 1-5.303-2.197A7.476 7.476 0 0 1 .507 8.31z",
			stroke: "#2B2B2B",
			fill: "#FFF"
		}), /* @__PURE__ */ _jsx("g", {
			fill: "#2B2B2B",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", { d: "M14.207 7.611h-2.52c-.063-2.333-.7-4.324-1.665-5.491 2.334.809 4.03 2.94 4.185 5.491zM7.611 1.84v5.771h-2.52c.093-2.924 1.167-5.367 2.52-5.771zM7.611 8.389v5.771c-1.353-.404-2.427-2.847-2.52-5.771h2.52zM8.389 14.16V8.389h2.52c-.093 2.924-1.167 5.367-2.52 5.771zM8.389 7.611V1.84c1.353.404 2.427 2.847 2.52 5.771h-2.52zM5.978 2.12c-.95 1.167-1.602 3.158-1.665 5.491h-2.52C1.95 5.06 3.644 2.93 5.978 2.12zM1.793 8.389h2.52c.063 2.333.7 4.324 1.665 5.491-2.334-.809-4.03-2.94-4.185-5.491zM10.022 13.88c.95-1.167 1.602-3.158 1.665-5.491h2.52c-.156 2.551-1.851 4.682-4.185 5.491z" })
		})]
	})
});
export default SvgTranslationblack;
